import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import Icon from "@mui/material/Icon";
import Input from '@mui/material/Input';
import Chip from '@mui/material/Chip';
import { Stack } from "@mui/material";
import { makeStyles, useTheme } from '@mui/material/styles';
import { ToastContainer, toast } from 'react-toastify';
import anmolLogo from "../../assets/images/anmol_logo_transparent.png";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import SoftSelect from "components/SoftSelect";
import { ThreeDots } from 'react-loader-spinner';
import { useDropzone } from "react-dropzone";
import "layouts/style.css";
import { Bars } from 'react-loader-spinner'
import Select from "react-select"

const VendorFormView=()=>{
    const navigate= useNavigate();
    const [loaderspinner, setLoaderSpinner] = useState(false);
    const [isMsme, setIsMsme] = useState(false);
    const [isfssi, setIsFssi] = useState(false);
    const toastId = React.useRef(null);
    const [loader, setLoader] = useState(false);
    const [formSubmitted, setIsFormSubmiteed] = useState(false);
    const [formValues, setFormValues] = useState({
      trade_name: { value: '', error: false }, // Trade Name(as per gst)*
      address: { value: '' }, // Address(to be registered as per GST)*
      typeOfFirm: { value: '', error: false }, // Type of Firm/Company*
      cin: { value: '' }, // CIN (if applicable)
      postal_code: { value: '' }, // Postal Code
      mca_roc_status: { value: '' }, // MCA/ROC status (for Co/LLP)
      latest_co_status: { value: '' }, // CIN (If MCA/ROC is Active)
      city: { value: '' }, // City*
      region: { value: '', error: false }, // Region
      state: { value: '', error: false }, // State*
      pin_code: { value: '' }, // Pin Code*
      website: { value: '' }, // Website
      telephone: { value: '' }, // Telephone
      email: { value: '', error: false }, // Email Address*
      proprietor_name: { value: '' }, // Name of Proprietor/Partner/Director*
      pan: { value: '', error: false }, // Permanent account number
      contact_person: { value: '' }, // Name of Contact Person*
      mobile_number: { value: '', error: false }, // Mobile Number*
      telephone_number: { value: '', error: false }, // Telephone Number*
      business_data: { value: '' , error: false}, // Business Data
      nature_of_business: { value: [],error: false }, // Nature of Business*
      business_category: { value: [],error: false }, // Business Category
      msme_registration_status: { value: '',error: false }, // MSME Registration Status.
      msme_registration_no: { value: '',error: false }, // MSME Registration no.
      msme_category: { value: '',error: false }, // MSME Category
      msme_type: { value: '',error: false }, // MSME Type
      fssi_registration_status: { value: '',error: false }, // FSSI Registration Status.
      fssi_regn_no: { value: '',error: false }, // FSSI Regn No
      fssi_valid_till: { value: '',error: false }, // FSSI Valid Till (dd-mm-yyyy)
      gstn: { value: '',error: false }, // GSTN No*.
      tan: { value: '',error: false }, // TAN*
      itr_filing_status: { value: '',error: false }, // Status of filing ITR of last 2 yrs.
      pan_linked_aadhaar: { value: '',error: false }, // PAN linked with Aadhaar
      tds_exemption: { value: '',error: false }, // TDS Exemption/Lower Deduction
      tds_nature_of_service: { value: '',error: false }, // Nature of Service for TDS
      tds_doc: { value: '',error: false },
      tds_section: { value: '',error: false }, // TDS to be Deducted u/s
      gst_turnover_prev_yr: { value: '',error: false }, // GST Turnover of Prev Yr.(Lakhs).
      prev_yr: { value: '',error: false }, // Prev Yr
      e_invoice_applicable: { value: '',error: false }, // E-Invoice Applicable
      bank_name: { value: '',error: false }, // Bank Name.
      ifsc_code: { value: '',error: false }, // IFSC Code
      bank_account_number: { value: '',error: false }, // Bank Account Number
      cheque_issued_name: { value: '',error: false }, // Cheque to be Issued in name of*
      gstn_document: { value: '',error: false }, // GSTN Document*
      pan_document: { value: '',error: false }, // PAN Document*
      date_of_fillup: { value: '',error: false }, // GSTN Document*
      signature: { value: '',error: false } ,
      declaration: {value: false, error: false}
    });

    useEffect(() => {
      let msme= localStorage.getItem("msme");
      let fssi= localStorage.getItem("fssi");
      let filledForm= localStorage.getItem("filledForm");
      setFormValues(JSON.parse(filledForm));
      setIsMsme(JSON.parse(msme));
      setIsFssi(JSON.parse(fssi));
    },[]);
    

    const handleFormChange = (field, value) => {
      let updatedValue = value;
  
      // Check if the field is one of the multi-selects
      if (field === "nature_of_business" || field === "business_category") {
          // For multi-select fields, we need to extract the 'value' from the selected options array
          updatedValue = value.map(option => option.value);
      }
  
      // Update the state for the given field
      setFormValues((prevState) => ({
          ...prevState,
          [field]: {
              ...prevState[field],
              value: updatedValue,
          },
      }));
  };
  

      const handleSubmitForm=(e)=>{
        e.preventDefault();
       navigate("/vendor/validation")
      }

    return(
      <>
      <Grid>
       
 
        <SoftBox py={0} className="customerblock">
        <Grid container spacing={3}>
        <Grid item xs={12} lg={12} className="headerForm">
        
        <SoftBox p={0} display="flex" alignItems="center" justifyContent="space-between">
 <img src={anmolLogo} alt="Logo" style={{ height: 100 }} />
 
 <SoftTypography  variant="h3" id="form_heading" style={{ flex: 1, textAlign: "center" }}>
  Vendor Registration
 </SoftTypography>
 
 {/* This empty box ensures the text remains centered */}
 <div style={{ width: 50 }}></div>
 </SoftBox>
 
 
        <Grid>
                      {loaderspinner ? <div style={{
                        position: 'fixed', width: "100%", height: '100%', backgroundColor: 'rgba(0, 0, 0, 0.3)',
                        zIndex: 200000, display: 'flex', justifyContent: 'center', alignItems: 'center', top: '0px', left: '0px',
                      }}>
                        <ThreeDots color="#fff" height={50} width={50} timeout={1000} visible={loaderspinner} />
 
                      </div> : ""}
        </Grid>
        
        </Grid>
        </Grid>
        </SoftBox>
         
         <SoftBox className="bp formBG">
           <form noValidate onSubmit={handleSubmitForm}>
          <SoftBox py={3} className="customerblock">
            <Grid container spacing={3}>
              <Grid item xs={12} lg={12}>
                <Card sx={{ overflow: "visible" }}>
                  <SoftBox p={3}>
                    <SoftTypography variant="h5" id="form_heading textUppercase">General Data</SoftTypography>
 
                    
 
                    <SoftBox mt={1}>
                      <Grid container spacing={3}>
                        <Grid item xs={12} sm={4}>
                          <SoftBox mb={3}>
                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                              <SoftTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize"
                              >
                                Trade Name(as per gst)*
                              </SoftTypography>
                            </SoftBox>
                            <SoftInput
                              name="Trade name"
                              id="trade_name"
                              error={formValues.trade_name.error} 
                              value={formValues.trade_name.value}
                              disabled
                              onChange={(e) => handleFormChange('trade_name', e.target.value)}
                              
                            />
                          </SoftBox>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <SoftBox mb={3}>
                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                              <SoftTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize"
                              >
                                Address(to be registered as per GST)*
                              </SoftTypography>
                            </SoftBox>
                            <SoftInput
                              name="Address"
                              id="address"
                              error={formValues.address.error}
                              value={formValues.address.value}
                              disabled
                              onChange={(e) => handleFormChange('address', e.target.value)}
                              
                            />
                          </SoftBox>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <SoftBox mb={3}>
                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                              <SoftTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize"
                              >
                                Type of Firm/Company*
                              </SoftTypography>
                            </SoftBox>
                            <SoftSelect
                              name="Type of Firm"
                              id="type_of_firm"
                              error={formValues.typeOfFirm.error}
                              value={[{value: formValues.typeOfFirm.value, label: formValues.typeOfFirm.value}]}
                              isDisabled
                              onChange={(e) => handleFormChange('typeOfFirm', e.value)}
                              options={[
                                { value: "Proprieter", label: "Proprieter" },
                                { value: "Partnership", label: "Partnership" },
                                { value: "Pvt Limited", label: "Pvt Limited" },
                                { value: "Limited", label: "Limited" },
                                { value: "LLP", label: "LLP" },
                                { value: "Trust", label: "Trust" },
                                { value: "AOP", label: "AOP" },
                                { value: "Other", label: "Other" },
                              ]}
                            />
                          </SoftBox>
                        </Grid>
                      </Grid>
                    </SoftBox>
 
                    <SoftBox mt={1}>
                      <Grid container spacing={3}>
                        <Grid item xs={12} sm={4}>
                          <SoftBox mb={3}>
                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                              <SoftTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize"
                              >
                               CIN (if applicable)
                              </SoftTypography>
                            </SoftBox>
                            <SoftInput
                              type="text"
                              placeholder="Postal Code"
                              id="postal_code"
                              disabled
                              value={formValues.cin.value}
                              onChange={(e) => handleFormChange('cin', e.target.value)}
                              size="medium"
                             
                               />
                          </SoftBox>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <SoftBox mb={3}>
                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                              <SoftTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize"
                              >
                                MCA/ROC status (for Co/LLP)
                              </SoftTypography>
                            </SoftBox>
                            <SoftSelect
                              name="Type of Firm"
                              id="type_of_firm"
                              // value={formValues.mca_roc_status.value}
                              value={[{value: formValues.mca_roc_status.value, label: formValues.mca_roc_status.value}]}
                              isDisabled
                              onChange={(e) => handleFormChange('mca_roc_status', e.value)}
                              options={[
                                { value: "Active", label: "Active" },
                                { value: "Strike Off", label: "Strike Off" },
                              ]}
                            />
                          </SoftBox>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <SoftBox mb={3}>
                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                              <SoftTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize"
                              >
                                CIN (If MCA/ROC is Active)
                              </SoftTypography>
                            </SoftBox>
                            <SoftInput  
                              type="file"
                              
                              value={formValues.latest_co_status.value}
                              disabled
                              onChange={(e) => handleFormChange('latest_co_status', e.target.file)}
                              placeholder="Street"
                              id="street"
                              size="medium" />
                          </SoftBox>
                        </Grid>
                      </Grid>
                    </SoftBox>
 
                    <SoftBox mt={1}>
                      <Grid container spacing={3}>
                        <Grid item xs={12} sm={4}>
                          <SoftBox mb={3}>
                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                              <SoftTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize"
                              >
                                City*
                              </SoftTypography>
                            </SoftBox>
                            <SoftInput
                              type="text"
                              id="city"
                              error={formValues.city.error}
                              value={formValues.city.value}
                              disabled
                              onChange={(e) => handleFormChange('city', e.target.value)}
                              size="medium" />
                          </SoftBox>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                        <SoftBox mb={3} id="mkcustomer">
                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                              <SoftTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize"
                              >
                                State*
                              </SoftTypography>
                            </SoftBox>
                            <SoftSelect
                              name="state"
                              id="state"
                              error={formValues.state.error}
                              // value={formValues.state.value}
                              value={[{value: formValues.state.value, label: formValues.state.value}]}
                              isDisabled
                              onChange={(e) => handleFormChange('state', e.value)}
                               options = {[
                                { value: "Andhra Pradesh", label: "Andhra Pradesh" },
                                { value: "Arunachal Pradesh", label: "Arunachal Pradesh" },
                                { value: "Assam", label: "Assam" },
                                { value: "Bihar", label: "Bihar" },
                                { value: "Chhattisgarh", label: "Chhattisgarh" },
                                { value: "Goa", label: "Goa" },
                                { value: "Gujarat", label: "Gujarat" },
                                { value: "Haryana", label: "Haryana" },
                                { value: "Himachal Pradesh", label: "Himachal Pradesh" },
                                { value: "Jharkhand", label: "Jharkhand" },
                                { value: "Karnataka", label: "Karnataka" },
                                { value: "Kerala", label: "Kerala" },
                                { value: "Madhya Pradesh", label: "Madhya Pradesh" },
                                { value: "Maharashtra", label: "Maharashtra" },
                                { value: "Manipur", label: "Manipur" },
                                { value: "Meghalaya", label: "Meghalaya" },
                                { value: "Mizoram", label: "Mizoram" },
                                { value: "Nagaland", label: "Nagaland" },
                                { value: "Odisha", label: "Odisha" },
                                { value: "Punjab", label: "Punjab" },
                                { value: "Rajasthan", label: "Rajasthan" },
                                { value: "Sikkim", label: "Sikkim" },
                                { value: "Tamil Nadu", label: "Tamil Nadu" },
                                { value: "Telangana", label: "Telangana" },
                                { value: "Tripura", label: "Tripura" },
                                { value: "Uttar Pradesh", label: "Uttar Pradesh" },
                                { value: "Uttarakhand", label: "Uttarakhand" },
                                { value: "West Bengal", label: "West Bengal" },
                              ]}
                              
                            />
                        </SoftBox>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                        <SoftBox mb={3} id="mkcustomer">
                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                              <SoftTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize"
                              >
                                Pin Code*
                              </SoftTypography>
                            </SoftBox>
                            <SoftInput
                              type="text"
                              id="pin_code"
                              error={formValues.pin_code.error}
                              value={formValues.pin_code.value}
                              disabled
                              onChange={(e) => handleFormChange('pin_code', e.target.value)}
                              size="medium"
                               />
                        </SoftBox>
                        </Grid>
                      </Grid>
                    </SoftBox>
 
                    <SoftBox mt={1}>
                      <Grid container spacing={3}>
                        <Grid item xs={12} sm={4}>
                          <SoftBox mb={3}>
                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                              <SoftTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize"
                              >
                                Website
                              </SoftTypography>
                            </SoftBox>
                            <SoftInput
                              type="text"
                              id="website"
                              name="website"
                              error={formValues.website.error}
                              value={formValues.website.value}
                              disabled
                              onChange={(e) => handleFormChange('website', e.target.value)}
                              size="medium"
                              
                              inputProps={{ maxLength: "10" }} />
                          </SoftBox>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                        <SoftBox mb={3} id="mkcustomer">
                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                              <SoftTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize"
                              >
                                Email Address*
                              </SoftTypography>
                            </SoftBox>
                            <SoftInput
                              name="email"
                              error={formValues.email.error}
                              value={formValues.email.value}
                              disabled
                              onChange={(e) => handleFormChange('email', e.target.value)}
                              type="email"
                              placeholder="Email"
                              inputProps={{ maxLength: "241" }}
                            />
                        </SoftBox>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                        <SoftBox mb={3} id="mkcustomer">
                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                              <SoftTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize"
                              >
                                Name of Proprietor/Partner/Director*
                              </SoftTypography>
                            </SoftBox>
                            <SoftInput
                              type="text"
                              id="proprieter"
                              error={formValues.proprietor_name.error}
                              value={formValues.proprietor_name.value}
                              disabled
                              onChange={(e) => handleFormChange('proprietor_name', e.target.value)}
                              name="proprieter"
                              size="medium"
                               />
                        </SoftBox>
                        </Grid>
                      </Grid>
                    </SoftBox>
 
                    {/* <SoftBox mt={1}>
                      <Grid container spacing={3}>
                      <Grid item xs={12} sm={4}>
                        <SoftBox mb={3} id="mkcustomer">
                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                              <SoftTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize"
                              >
                                Name of contact person*
                              </SoftTypography>
                            </SoftBox>
                            <SoftSelect
                              name="account_group"
                              id="account_group"
                              value={formValues.account_group.value}
                              onChange={(e) => handleFormChange('account_group', e.value)}
                              options={[
                                { value: "ZYRN", label: "ZYRN" }
                              ]}
                            />
                        </SoftBox>
                        </Grid>
                      <Grid item xs={12} sm={4}>
                          
                        </Grid>
                        <Grid item xs={12} sm={4}>
                        
                        </Grid>
                        
                      </Grid>
                    </SoftBox> */}
 
 <SoftBox mt={1}>
                      <Grid container spacing={3}>
                        <Grid item xs={12} sm={4}>
                          <SoftBox mb={3}>
                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                              <SoftTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize"
                              >
                                Name of Contact Person*
                              </SoftTypography>
                            </SoftBox>
                            <SoftInput
                              type="text"
                            
                              error={formValues.contact_person.error}
                              id="contact_person"
                              disabled
                              value={formValues.contact_person.value}
                              onChange={(e) => handleFormChange('contact_person', e.target.value)}
                              size="medium" />
                          </SoftBox>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                        <SoftBox mb={3} id="mkcustomer">
                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                              <SoftTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize"
                              >
                                Mobile Number*
                              </SoftTypography>
                            </SoftBox>
                            <SoftInput
                            type="number"
                              name="mobile"
                              id="mobile"
                              error={formValues.mobile_number.error}
                              value={formValues.mobile_number.value}
                              disabled
                              onChange={(e) => handleFormChange('mobile_number', e.target.value)}
                              
                            />
                        </SoftBox>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                        <SoftBox mb={3} id="mkcustomer">
                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                              <SoftTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize"
                              >
                                Telephone Number*
                              </SoftTypography>
                            </SoftBox>
                            <SoftInput
                            type="number"
                              name="telephone"
                              id="type_of_firm"
                              error={formValues.telephone_number.error}
                              value={formValues.telephone_number.value}
                              disabled
                              onChange={(e) => handleFormChange('telephone_number', e.target.value)}
                              
                            />
                        </SoftBox>
                        </Grid>
                      </Grid>
                    </SoftBox>
                    
 
                    
 
                  </SoftBox>
                </Card>
              </Grid>
            </Grid>
          </SoftBox>
          <SoftBox py={3} className="customerblock">
            <Grid container spacing={3}>
              <Grid item xs={12} lg={12}>
                <Card sx={{ overflow: "visible" }}>
                  <SoftBox p={3}>
                    <SoftTypography variant="h5" id="form_heading">Business Data</SoftTypography>
 
                    
 <Grid container spacing={3} alignItems="center">
  <Grid item xs={12} sm={4}>
    <SoftBox mb={2}>
      <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
        <SoftTypography component="label" variant="caption" fontWeight="bold" textTransform="capitalize">
          Nature of Business*
        </SoftTypography>
      </SoftBox>
      <Select
        isMulti
        name="nature_of_business"
        id="nature_of_business"
        error={formValues.nature_of_business.error}
        // value={formValues.nature_of_business.value}
        isDisabled
        value={[{value: formValues.nature_of_business.value, label: formValues.nature_of_business.value}]}
        onChange={(selectedOptions) => handleFormChange("nature_of_business", selectedOptions)}
        options={[
          { value: "Capital Goods", label: "Capital Goods" },
          { value: "Manufacturing", label: "Manufacturing" },
          { value: "Trading", label: "Trading" },
          { value: "Exporter", label: "Exporter" },
          { value: "Service", label: "Service" },
          { value: "CSR", label: "CSR" },
          { value: "OTPY", label: "OTPY" },
        ]}
        styles={{
          control: (provided) => ({
            ...provided,
            minHeight: "34px",
            fontSize: "9px",
          }),
          multiValue: (provided) => ({
            ...provided,
            fontSize: "10px",
            padding: "2px",
          }),
          placeholder: (provided) => ({
            ...provided,
            fontSize: "12px",
          }),
          dropdownIndicator: (provided) => ({
            ...provided,
            padding: "4px",
          }),
        }}
      />
    </SoftBox>
  </Grid>
 
  <Grid item xs={12} sm={4}>
    <SoftBox mb={2}>
      <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
        <SoftTypography component="label" variant="caption" fontWeight="bold" textTransform="capitalize">
          Business Category
        </SoftTypography>
      </SoftBox>
      <Select
        isMulti
        name="business_category"
        id="business_category"
        error={formValues.business_category.error}
        value={[{value: formValues.business_category.value, label: formValues.business_category.value}]}
        isDisabled
        // value={formvalues.business}
        onChange={(selectedOptions) => handleFormChange("business_category", selectedOptions)}
        options={[
          { value: "Raw Mat", label: "Raw Mat" },
          { value: "Packaging Mat", label: "Packaging Mat" },
          { value: "Engg Store", label: "Engg Store" },
          { value: "Fuel", label: "Fuel" },
          { value: "Transporter", label: "Transporter" },
          { value: "Contractor", label: "Contractor" },
          { value: "Oth Services", label: "Oth Services" },
          { value: "Capital", label: "Capital" },
          { value: "Adv & Sales Prom", label: "Adv & Sales Prom" },
        ]}
        styles={{
          control: (provided) => ({
            ...provided,
            minHeight: "34px",
            fontSize: "9px",
          }),
          multiValue: (provided) => ({
            ...provided,
            fontSize: "10px",
            padding: "2px",
          }),
          placeholder: (provided) => ({
            ...provided,
            fontSize: "12px",
          }),
          dropdownIndicator: (provided) => ({
            ...provided,
            padding: "4px",
          }),
        }}
      />
    </SoftBox>
  </Grid>
 
 
 
 
 
 {isMsme &&
 
                    
                      <>
                      <Grid item xs={12} sm={4}>
    <SoftBox mb={2}>
      <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
        <SoftTypography component="label" variant="caption" fontWeight="bold" textTransform="capitalize">
          MSME Registration Status.
        </SoftTypography>
      </SoftBox>
      <SoftSelect
                              name="msme_status"
                              id="msme_status"
                              className="formstyle"
                              error={formValues.msme_registration_status.error}
                              value={[{value: formValues.msme_registration_status.value, label: formValues.msme_registration_status.value}]}
                              isDisabled
                              // value={formValues.msme_registration_status.value}
                              onChange={(e) => handleFormChange('msme_registration_status', e.value)}
                              options={[
                                { value: "Registered", label: "Registered" },
                                { value: "Large Unit", label: "Large Unit" },
                              ]}
                            />
    </SoftBox>
                       </Grid>
                        <Grid item xs={12} sm={4}>
                          <SoftBox mb={3}>
                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                              <SoftTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize"
                              >
                                MSME Registration no.
                              </SoftTypography>
                            </SoftBox>
                            <SoftInput
                              name="msme_no"
                              id="msme_no"
                              className="formstyle"
                              error={formValues.msme_registration_no.error}
                              value={formValues.msme_registration_no.value}
                              disabled
                              type="text"
                              onChange={(e) => handleFormChange('msme_registration_no', e.target.value)}
                            />
                          </SoftBox>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <SoftBox mb={3}>
                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                              <SoftTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize"
                              >
                               MSME Category
                              </SoftTypography>
                            </SoftBox>
                            <SoftSelect
                              name="msme_category"
                              id="msme_category"
                              error={formValues.msme_category.error}
                              // value={formValues.msme_category.value}
                              value={[{value: formValues.msme_category.value, label: formValues.msme_category.value}]}
                              isDisabled
                              onChange={(e) => handleFormChange('msme_category', e.value)}
                              options={[
                                { value: "Macro", label: "Macro" },
                                { value: "Small", label: "Small" },
                                { value: "Medium", label: "Medium" },
                              ]}
                            />
                          </SoftBox>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <SoftBox mb={3} id="name3">
                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                              <SoftTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize"
                              >
                               MSME Type
                              </SoftTypography>
                            </SoftBox>
                            <SoftSelect
                              name="msme_type"
                              id="msme_type"
                              error={formValues.msme_type.error}
                              // value={formValues.msme_type.value}
                              value={[{value: formValues.msme_type.value, label: formValues.msme_type.value}]}
                              isDisabled
                              onChange={(e) => handleFormChange('msme_type', e.value)}
                              options={[
                                { value: "A", label: "A" },
                                { value: "B", label: "B" },
                                { value: "C", label: "C" },
                                { value: "D", label: "D" },
                                { value: "E", label: "E" },
                                { value: "F", label: "F" },
                              ]}
                            />
                          </SoftBox>
                        </Grid>
                       
                      </>
                   
 }
 {isfssi &&
                    <>
                     
                        {/* <Grid item xs={12} sm={4}>
                          <SoftBox mb={3}>
                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                              <SoftTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize"
                              >
                                FSSI Registration Status.
                              </SoftTypography>
                            </SoftBox>
                            <SoftSelect
                              name="fssi_status"
                              id="fssi_status"
                              error={formValues.fssi_registration_status.error}
                              // value={formValues.fssi_registration_status.value}
                              onChange={(e) => handleFormChange('fssi_registration_status', e.value)}
                              options={[
                                { value: "Registered", label: "Registered" },
                                { value: "Un-registered", label: "Un-registered" },
                                
                              ]}
                            />
                          </SoftBox>
                        </Grid> */}
                        <Grid item xs={12} sm={4}>
                          <SoftBox mb={3}>
                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                              <SoftTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize"
                              >
                               FSSAI Regn No
                              </SoftTypography>
                            </SoftBox>
                            <SoftInput
                            type="text"
                              name="fssi_reg"
                              id="fssi_reg"
                              disabled
                              error={formValues.fssi_regn_no.error}
                              value={formValues.fssi_regn_no.value}
                              onChange={(e) => handleFormChange('fssi_regn_no', e.target.value)}
                            />
                          </SoftBox>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <SoftBox mb={3} id="name3">
                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                              <SoftTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize"
                              >
                               FSSAI Valid Till
                              </SoftTypography>
                            </SoftBox>
                            <SoftInput
                            type="date"
                              name="itr_filing"
                              id="fssi_valid"
                              disabled
                              error={formValues.fssi_valid_till.error}
                              // value={formValues.fssi_valid_till.value}
                              onChange={(e) => handleFormChange('fssi_valid_till', e.target.value)}
                            />
                          </SoftBox>
                        </Grid>
 
                        
                       
                      
                    </>
 }
                    <>
                        <Grid item xs={12} sm={4}>
                          <SoftBox mb={3}>
                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                              <SoftTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize"
                              >
                                GSTN No*.
                              </SoftTypography>
                            </SoftBox>
                            <SoftInput
                            type="text"
                              name="gstn"
                              id="Gstn"
                              error={formValues.gstn.error} 
                              value={formValues.gstn.value}
                              disabled
                              onChange={(e) => handleFormChange('gstn', e.target.value)}
                            />
                          </SoftBox>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <SoftBox mb={3}>
                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                              <SoftTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize"
                              >
                               PAN*
                              </SoftTypography>
                            </SoftBox>
                            <SoftInput
                            type="text"
                              name="pan"
                              id="pan"
                              error={formValues.pan.error}
                              value={formValues.pan.value}
                              disabled
                              onChange={(e) => handleFormChange('pan', e.target.value)}
                            />
                          </SoftBox>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <SoftBox mb={3} id="name3">
                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                              <SoftTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize"
                              >
                               TAN*
                              </SoftTypography>
                            </SoftBox>
                            <SoftInput
                            type="text"
                              name="tan"
                              id="tan"
                              error={formValues.tan.error}
                              value={formValues.tan.value}
                              disabled
                              onChange={(e) => handleFormChange('tan', e.target.value)}
                            />
                          </SoftBox>
                        </Grid>
                    </>
                        <Grid item xs={12} sm={4}>
                          <SoftBox mb={3}>
                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                              <SoftTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize"
                              >
                                Status of filing ITR of last 2 yrs.
                              </SoftTypography>
                            </SoftBox>
                            <SoftSelect
                              name="itr_filing"
                              id="itr_filing"
                              error={formValues.itr_filing_status.error}
                              // value={formValues.itr_filing_status.value}
                              value={[{value: formValues.itr_filing_status.value, label: formValues.itr_filing_status.value}]}
                              isDisabled
                              onChange={(e) => handleFormChange('itr_filing_status', e.target.value)}
                              options={[
                                { value: "Filed", label: "Filed" },
                                { value: "Not Filed", label: "Not Filed" },
                                
                              ]}
                            />
                          </SoftBox>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <SoftBox mb={3}>
                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                              <SoftTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize"
                              >
                               PAN linked with Aadhaar
                              </SoftTypography>
                            </SoftBox>
                            <SoftSelect
                              name="pan_linked_aadhaar"
                              id="pan_linked_aadhaar"
                              error={formValues.pan_linked_aadhaar.error}
                              // value={formValues.pan_linked_aadhaar.value}
                              value={[{value: formValues.pan_linked_aadhaar.value, label: formValues.pan_linked_aadhaar.value}]}
                              isDisabled
                              onChange={(e) => handleFormChange('pan_linked_aadhaar', e.value)}
                              options={[
                                { value: "Yes", label: "Yes" },
                                { value: "No", label: "No" },
                                
                              ]}
                            />
                          </SoftBox>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <SoftBox mb={3} id="name3">
                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                              <SoftTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize"
                              >
                               TDS Exemption/Lower Deduction
                              </SoftTypography>
                            </SoftBox>
                            <SoftSelect
                              name="tds_ememption"
                              id="tds_exemption"
                              error={formValues.tds_exemption.error}
                              // value={formValues.tds_exemption.value}
                              value={[{value: formValues.tds_exemption.value, label: formValues.tds_exemption.value}]}
                              isDisabled
                              onChange={(e) => handleFormChange('tds_exemption', e.value)}
                              options={[
                                { value: "Yes", label: "Yes" },
                                { value: "No", label: "No" },
                                
                              ]}
                            />
                          </SoftBox>
                        </Grid>
                   
                        <Grid item xs={12} sm={4}>
                          <SoftBox mb={3}>
                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                              <SoftTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize"
                              >
                                If Yes, then please attach TDS Exemption/Lower Deduction Certificate.
                              </SoftTypography>
                            </SoftBox>
                            <SoftInput
                              type="file"
                              id="tds_doc"
                              
                              error={formValues.tds_doc.error}
                              value={formValues.tds_doc.value}
                              disabled
                              onChange={(e) => handleFormChange('tds_doc', e.target.file)}
                            />
                          </SoftBox>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <SoftBox mb={3}>
                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                              <SoftTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize"
                              >
                               Nature of Service for TDS
                              </SoftTypography>
                            </SoftBox>
                            <SoftInput
                            type="text"
                              name="tds_nature"
                              id="td_nature"
                              error={formValues.tds_nature_of_service.error}
                              value={formValues.tds_nature_of_service.value}
                              disabled
                              onChange={(e) => handleFormChange('tds_nature_of_service', e.target.value)}
                            />
                          </SoftBox>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <SoftBox mb={3} id="name3">
                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                              <SoftTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize"
                              >
                               TDS to be Deducted u/s
                              </SoftTypography>
                            </SoftBox>
                            <SoftInput
                            type="text"
                              name="tds_section"
                              id="tds_section"
                              error={formValues.tds_section.error}
                              value={formValues.tds_section.value}
                              disabled
                              onChange={(e) => handleFormChange('tds_section', e.target.value)}
                            />
                          </SoftBox>
                        </Grid>
 
                   
                        <Grid item xs={12} sm={4}>
                          <SoftBox mb={3}>
                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                              <SoftTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize"
                              >
                                GST Turnover of Prev Yr.(Lakhs).
                              </SoftTypography>
                            </SoftBox>
                            <SoftInput
                              type="number"
                              id="gst_turnover"
                              error={formValues.gst_turnover_prev_yr.error}
                              value={formValues.gst_turnover_prev_yr.value}
                              disabled
                              onChange={(e) => handleFormChange('gst_turnover_prev_yr', e.target.value)}
                            />
                          </SoftBox>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <SoftBox mb={3}>
                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                              <SoftTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize"
                              >
                               Prev Yr
                              </SoftTypography>
                            </SoftBox>
                            <SoftInput
                            type="text"
                              name="prev_yr"
                              id="prev_yr"
                              error={formValues.prev_yr.error}
                              value={formValues.prev_yr.value}
                              disabled
                              onChange={(e) => handleFormChange('prev_yr', e.target.value)}
                            />
                          </SoftBox>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <SoftBox mb={3} id="name3">
                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                              <SoftTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize"
                              >
                               E-Invoice Applicable
                              </SoftTypography>
                            </SoftBox>
                            <SoftSelect
                              name="e-invoice"
                              id="e-invoice"
                              // value={formValues.e_invoice_applicable.value}
                              value={[{value: formValues.e_invoice_applicable.value, label: formValues.e_invoice_applicable.value}]}
                              error={formValues.e_invoice_applicable.error}
                              isDisabled
                              onChange={(e) => handleFormChange('e_invoice_applicable', e.value)}
                              options={[
                                { value: "Yes", label: "Yes" },
                                { value: "No", label: "No" },
                                
                              ]}
                            />
                          </SoftBox>
                        </Grid>
 
 
                        <Grid item xs={12} sm={4}>
                          <SoftBox mb={3}>
                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                              <SoftTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize"
                              >
                                Bank Name.
                              </SoftTypography>
                            </SoftBox>
                            <SoftInput
                              type="text"
                              id="bank_name"
                              error={formValues.bank_name.error}
                              value={formValues.bank_name.value}
                              disabled
                              onChange={(e) => handleFormChange('bank_name', e.target.value)}
                            />
                          </SoftBox>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <SoftBox mb={3}>
                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                              <SoftTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize"
                              >
                               IFSC Code
                              </SoftTypography>
                            </SoftBox>
                            <SoftInput
                            type="text"
                              name="ifsc_code"
                              id="ifsc_code"
                              error={formValues.ifsc_code.error}
                              value={formValues.ifsc_code.value}
                              disabled
                              onChange={(e) => handleFormChange('ifsc_code', e.target.value)}
                            />
                          </SoftBox>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <SoftBox mb={3} id="name3">
                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                              <SoftTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize"
                              >
                               Bank Account Number
                              </SoftTypography>
                            </SoftBox>
                            <SoftInput
                            type="text"
                              name="incoterms2"
                              id="incoterms2"
                              error={formValues.bank_account_number.error}
                              value={formValues.bank_account_number.value}
                              disabled
                              onChange={(e) => handleFormChange('bank_account_number', e.target.value)}
                            />
                          </SoftBox>
                        </Grid>
                        
                    
 
                   
                        <Grid item xs={12} sm={4}>
                          <SoftBox mb={3}>
                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                              <SoftTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize"
                              >
                                Cheque to be Issued in name of*
                              </SoftTypography>
                            </SoftBox>
                            <SoftInput
                              type="text"
                              size="medium"
                              name="cheque_issued_name"
                              id="cheque_issued_name"
                              error={formValues.cheque_issued_name.error}
                              disabled
                              // value={formValues.cheque_issued_name.value}
                              onChange={(e) => handleFormChange('cheque_issued_name', e.target.value)}
                              
                            />
                          </SoftBox>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                        <SoftBox mb={3} id="mkcustomer">
                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                              <SoftTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize"
                              >
                                GSTN Document*
                              </SoftTypography>
                            </SoftBox>
                            <SoftInput
                              type="file"
                              size="medium"
                              name="gstn_document"
                              id="gstn_document"
                              error={formValues.gstn_document.error}
                              disabled
                              // value={formValues.gstn_document.value}
                              onChange={(e) => handleFormChange('gstn_document', e.target.file)}
                            />
                        </SoftBox>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                        <SoftBox mb={3}>
                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                              <SoftTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize"
                              >
                                PAN Document*
                              </SoftTypography>
                            </SoftBox>
                            <SoftInput
                              type="file"
                              name="pan"
                              id="pan"
                              error={formValues.pan_document.error}
                              value={formValues.pan_document.value}
                              disabled
                              onChange={(e) => handleFormChange('pan_document', e.target.file)}
                              placeholder="GSTN"
                              size="medium"
                              // inputProps={{ maxLength: "15" }}
                            />
                          </SoftBox>
                        </Grid>
                     </Grid> 
                  </SoftBox>
                </Card>
              </Grid>
            </Grid>
          </SoftBox>
          <SoftBox py={3} className="customerblock">
 <Grid container spacing={3}>
  <Grid item xs={12} lg={12}>
    <Card sx={{ overflow: "visible" }}>
      <SoftBox p={1}>
 
        {/* Submit Button */}
        <Grid container justifyContent="flex-end" mt={2}>
          <Grid item>
            <SoftButton type="submit" variant="contained" color="primary">
              Go Back
            </SoftButton>
          </Grid>
        </Grid>
      </SoftBox>
    </Card>
  </Grid>
 </Grid>
 </SoftBox>
 
          </form>
          </SoftBox>
         
      </Grid>
      </>
 
    )
}

export default VendorFormView